import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAntdTable, useRequest } from "ahooks";
import { createStore } from "hox";
import {
  standardVersion,
  treeData,
  getItem,
} from "@/api/standard";
function useHook() {
  const [searchParams] = useSearchParams();
  const domainId = searchParams.get("domainId");
  const dictName = searchParams.get("dictName") as any;
  const [searchVal, setSearchVal] = useState<any>({});
  // const typeEnum = ["", "CDASH_Model", "CDASHIG", "SDTM", "SDTMIG"];
  const typeEnum = {
    "CDASH_Model": 1, "CDASHIG": 2, "SDTM": 3, "SDTMIG": 4,
    "CDASH_Model中文": 1, "CDASHIG中文": 2, "SDTM中文": 3, "SDTMIG中文": 4
  }
  const standardType = typeEnum?.[dictName] || '';
  const getVersion: any = useRequest(
    async () => {
      const res = await standardVersion({ dictName, type: 1, domainId });
      if (res) {
        setSearchVal({});
        setSearchVal({ versionId: res[0]?.dictId });
        return res;
      }
    },
    {
      refreshDeps: [dictName],
    }
  );

  const getTreeData = useRequest(
    async (params) => {
      const res = await treeData({
        ...params,
        type: 1,
        parentId: domainId,
        dictId: searchVal.versionId,
      });
      if (res) {
        setSearchVal((prev) => ({ ...prev, directoryId: res[0]?.id }));
        return res;
      }
    },
    {
      debounceWait: 300,
      ready: searchVal.versionId ? true : false,
      refreshDeps: [searchVal.versionId],
    }
  );

  const getTableData = useAntdTable(
    async ({ pageSize, current }) => {
      let req: any = {
        type: 1,
        pageSize,
        pageNumber: current,
        dictId: searchVal.versionId,
        directoryId: searchVal.directoryId,
        standardType,
      }
      if (dictName.toUpperCase() === 'OMOP CDM') {
        req = {
          ...req,
          stadnardOmopSearch: searchVal.searchWord
        }
      } else {
        req = {
          ...req,
          searchWord: encodeURI(searchVal.searchWord || '')
        }
      }
      const res: any = await getItem(req);
      return {
        total: res.totalCount || 0,
        list: res.content || [],
      };
    },
    {
      ready: searchVal.versionId && searchVal.directoryId ? true : false,
      refreshDeps: [
        searchVal.versionId,
        searchVal.directoryId,
        searchVal.searchWord,
      ],
    }
  );

  useEffect(() => {
    setSearchVal({ searchWord: "" });
  }, [dictName]);

  return {
    searchVal,
    getVersion,
    getTreeData,
    getTableData,
    setSearchVal,
    dictName,
  };
}

export const [useStandard, StandardProvider] = createStore(useHook);
